<mat-form-field>
  <input type="text"
    matInput
    placeholder="Search"
    [formControl]="itemSearch"
    [matAutocomplete]="auto">
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete"
  [displayWith]="render"
  (optionSelected)="updateValue($event.option)">
  <mat-option *ngFor="let option of itemList | async"
    [value]="option">
    {{ render(option) }}
  </mat-option>
</mat-autocomplete>